import React from 'react'

class CloudwaysHeader extends React.Component {
	render() {
		document.body.style = 'background: #f0f0f0'
		return <div className="cws">
			<div className="navbar">
				<div className="navbar-inner">
					<img className="cloudways-logo" src="/assets/cloudways/cws-logo.svg" alt="Flywheel"/>
					<img className="blogvault-logo" src="/assets/cloudways/powered-by-blogvault.svg" alt="Powered by BlogVault"/>
				</div>
			</div>
		</div>
	}
}

export default CloudwaysHeader
